import React from "react";
import NavBar from "../components/NavBar";
import HomeSellingGuidePage from "../components/HomeSellingGuidePage";
import Footer from "../components/Footer";

const HomeSellingGuide = () => {
    return(
        <div>
            <NavBar/>
            <HomeSellingGuidePage/>
            <Footer/>
        </div>
    )
}

export default HomeSellingGuide;